import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class ProductImageBaseComponent extends BaseComponent {
  public text: string = "ProductImage";

  constructor(public userService: UserService) {
    super(userService);
  }
}
